import { FC } from 'react'
import { useQuery } from 'react-query'
import { fetchArtists } from 'src/services'
import Loading from 'src/components/Loading/Loading'
import Layout from 'src/containers/Layout/Layout'
import ArtistList from 'src/containers/Artist/ArtistList'

const ArtistListPage: FC = () => {
  const { data, isFetching, isLoading } = useQuery('artists', () =>
    fetchArtists(),
  )
  if (isFetching || isLoading || !data) return <Loading />
  return (
    <Layout>
      <ArtistList artists={data} />
    </Layout>
  )
}

export default ArtistListPage
